import { render, staticRenderFns } from "./MakeForm.vue?vue&type=template&id=3d823faa"
import script from "./MakeForm.vue?vue&type=script&lang=js"
export * from "./MakeForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/componenterpserver/gitrepo/unitmodeler/jp-ui/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('3d823faa')) {
      api.createRecord('3d823faa', component.options)
    } else {
      api.reload('3d823faa', component.options)
    }
    module.hot.accept("./MakeForm.vue?vue&type=template&id=3d823faa", function () {
      api.rerender('3d823faa', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/modules/form/MakeForm.vue"
export default component.exports